import { RootState } from 'src/state/RootState';

export function getIsQueryChanged(state: RootState, query: string): boolean {
    return state.search.params.query !== query;
}
